module.exports = __webpack_public_path__ + "static/media/background.8ef31bd2.jpg";